// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"2cb7d83d","403":"032877dd","787":"60ecf941","876":"6a514aeb","952":"75b14d23"}[chunkId] + ".chunk.js";
};